export default __webpack_public_path__ + "static/media/quero.29a64784.png";